import React, { useEffect } from "react";

import { useContext } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Grid, makeStyles } from "@material-ui/core";
import DashboardWidget from "./components/Dashboard-Widget/Dashboard-Widget";
import SpinnerLoading from "components/spinner-loading/spinner-loading";
import MessageBox from "components/MessageBox/MessageBox";
import { getDashboardCounts } from "actions/actions-global";
import { getProgramsAssignedToLoginList } from "actions/actions-programs";
import SnackbarError from "components/snackbar/snackbar-error";
import { ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED } from "actions/action-constants";
/*** signed in user */
import { CONTEXT_USER } from "App";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
}));
const Dashboard = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const programsAssigned = useSelector(
    (state) => state.programsR.programsassignedtologin
  );
  const globalsList = useSelector((state) => state.globalsR);
  const { loading, error } = globalsList;
  /*** SIGNED IN USER DETAILS */
  const CONST_CONTEXT_USER = useContext(CONTEXT_USER);
  useEffect(() => {
    dispatch(getDashboardCounts(CONST_CONTEXT_USER.id));
    dispatch(getProgramsAssignedToLoginList(CONST_CONTEXT_USER.id));
  }, [dispatch]);

  return (
    <div>
      {loading ? (
        <SpinnerLoading />
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <div className={classes.root}>
          {programsAssigned.length <= 1 ? (
            <div>
              <h4>{ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED}</h4>
              <SnackbarError
                variant="error"
                message={ERROR_MESSAGE_NO_PROGRAMS_ASSIGNED}
              />
            </div>
          ) : (
            <div>
              <Grid container spacing={2}>
                <Grid item lg={6} sm={6} xl={3} xs={12}>
                  {/* <Budget referralsCount={globalsList.referrals.pendingCount} /> */}
                  <DashboardWidget
                    title="Referrals"
                    count={globalsList.referrals}
                    link="/referrals/"
                    icon={0}
                  />
                  {CONST_CONTEXT_USER.role === 3 ||
                  CONST_CONTEXT_USER.role === 4 ? (
                    <DashboardWidget
                      title="Archived Referrals"
                      count={globalsList.archivedreferrals}
                      link="/archivedreferrals/"
                      icon={2}
                    />
                  ) : (
                    ""
                  )}
                </Grid>

                <Grid item lg={6} sm={6} xl={3} xs={12}>
                  {/* <TotalUsers clientsCount={globalsList.clients.pendingCount} /> */}
                  <DashboardWidget
                    title="Clients"
                    count={globalsList.clients}
                    link="/clients/"
                    icon={1}
                  />
                  {CONST_CONTEXT_USER.role === 3 ||
                  CONST_CONTEXT_USER.role === 4 ? (
                    <DashboardWidget
                      title="Archived Clients"
                      count={globalsList.archivedclients}
                      link="/archivedclients/"
                      icon={2}
                    />
                  ) : (
                    ""
                  )}
                </Grid>

                <Grid item lg={6} sm={6} xl={3} xs={12}>
                  {/* <TotalUsers postdischargesCount={globalsList.postdischarges.pendingCount} /> */}
                  <DashboardWidget
                    title="Post Discharges"
                    count={globalsList.postdischarges}
                    link="/postdischarges/"
                    icon={1}
                  />

                  {CONST_CONTEXT_USER.role === 3 ||
                  CONST_CONTEXT_USER.role === 4 ? (
                    <DashboardWidget
                      title="Archived Post Discharges"
                      count={globalsList.archivedpostdischarges}
                      link="/archivedpostdischarges/"
                      icon={2}
                    />
                  ) : (
                    ""
                  )}
                </Grid>

                {CONST_CONTEXT_USER.role === 2 ||
                CONST_CONTEXT_USER.role === 3 ||
                CONST_CONTEXT_USER.role === 4 ? (
                  <React.Fragment>
                    <Grid item lg={6} sm={6} xl={3} xs={12}>
                      {/* empty space for proper formating */}
                    </Grid>
                    <Grid item lg={6} sm={6} xl={3} xs={12}>
                      <DashboardWidget
                        title="90 days Post Discharges"
                        count={globalsList.postdischarges90d}
                        link="/postdischarges90d/"
                        icon={1}
                      />
                      <DashboardWidget
                        title="180 days Post Discharges"
                        count={globalsList.postdischarges180d}
                        link="/postdischarges180d/"
                        icon={1}
                      />
                    </Grid>
                    <Grid item lg={6} sm={6} xl={3} xs={12}>
                      <DashboardWidget
                        title="12 months Post Discharges"
                        count={globalsList.postdischarges12m}
                        link="/postdischarges12m/"
                        icon={1}
                      />
                      <DashboardWidget
                        title="24 months Post Discharges"
                        count={globalsList.postdischarges24m}
                        link="/postdischarges24m/"
                        icon={1}
                      />
                    </Grid>
                    <Grid item lg={6} sm={6} xl={3} xs={12}>
                      <DashboardWidget
                        title="36 months Post Discharges"
                        count={globalsList.postdischarges36m}
                        link="/postdischarges36m/"
                        icon={1}
                      />
                    </Grid>
                  </React.Fragment>
                ) : (
                  ""
                )}

                <Grid item lg={6} sm={6} xl={3} xs={12}>
                  {/* empty space for proper formating */}
                </Grid>
              </Grid>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default Dashboard;
